export const GET_SCAN_PHOTO_REQUEST = 'GET_SCAN_PHOTO_REQUEST' as const;
export const GET_SCAN_PHOTO_SUCCESS = 'GET_SCAN_PHOTO_SUCCESS' as const;
export const GET_SCAN_PHOTO_ERROR = 'GET_SCAN_PHOTO_ERROR' as const;

export const SET_TYPE_SCAN = 'SET_TYPE_SCAN' as const;
export const CLEAN_SCAN_IMG = 'CLEAN_SCAN_IMG' as const;
export const CLEAN_SCAN = 'CLEAN_SCAN' as const;
